<template>
    <modal
        :name="name"
        :adaptive="true"
        :scrollable="true"
        :width="width"
        height="auto"
        @before-open="beforeOpen"
        @before-close="$emit('hide')"
    >
        <div class="p-xl">
            <div v-if="title" class="flex items-center mb-2xl">
                <h1 class="m-0 text-md">{{ title }}</h1>
            </div>

            <div v-if="errors.length" class="alert alert-error font-normal">
                <div v-for="error in errors">
                    <div class="font-bold">{{ error.message }}</div>

                    <ul v-if="error.validationErrors" class="list-reset mt-md">
                        <li v-for="validationError in error.validationErrors">
                            {{ validationError[0] }}
                        </li>
                    </ul>
                </div>
            </div>

            <form
                ref="form"
                v-loading="loading"
                autocomplete="off"
                @submit.prevent="save"
            >
                <slot />

                <div class="flex flex-wrap-reverse justify-between mt-2xl">
                    <button
                        type="button"
                        class="btn btn-lg is-ghost"
                        @click="hide"
                    >
                        Avbryt
                    </button>
                    <slot name="primary-action">
                        <button
                            :class="primaryButtonClass"
                            type="submit"
                            class="btn btn-lg is-primary mb-md md:mb-0"
                        >
                            {{ primaryButtonText }}
                        </button>
                    </slot>
                </div>
            </form>
        </div>
    </modal>
</template>

<script>
    export default {
        props: {
            title: {
                required: false,
                type: String,
                default: '',
            },
            name: {
                required: true,
                type: String,
            },
            primaryButtonText: {
                type: String,
                default: 'Spara',
            },
            primaryButtonClass: {
                type: String,
                default: 'is-primary',
            },
            width: {
                type: [String, Number],
                default: 600,
            },
            method: {
                type: String,
                default: 'post',
            },
            action: {
                type: String,
                required: true,
            },
            redirectTo: {
                type: String,
                default: null,
            },
            callback: {
                type: Function,
                default: null,
            },
            files: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data() {
            return {
                errors: [],
                loading: false,
            };
        },
        methods: {
            hide() {
                this.$modal.hide(this.name);
            },
            beforeOpen(event) {
                this.$emit('before-open', event);
            },
            save() {
                this.errors = [];

                const formData = new FormData(this.$refs.form);
                this.loading = true;

                const config = {};
                let method = this.method.toLowerCase();

                if (['patch', 'delete'].indexOf(method) !== -1) {
                    formData.append('_method', method.toUpperCase());
                    method = 'post';
                }

                if (this.files === true) {
                    config.headers = {
                        'Content-Type': 'multipart/form-data',
                    };
                }

                axios[method](this.action, formData, config)
                    .then((response) => {
                        if (this.redirectTo !== null) {
                            window.location = this.redirectTo;

                            return;
                        }

                        if (Object.prototype.hasOwnProperty.call(response.data, 'redirectTo')) {
                            window.location = response.data.redirectTo;

                            return;
                        }

                        this.loading = false;

                        if (this.callback) {
                            this.callback(response);
                        }
                    })
                    .catch((error) => {
                        if (error.response.status === 422 && error.response.data.errors) {
                            this.errors.push({
                                message: 'Något gick fel:',
                                validationErrors: error.response.data.errors,
                            });
                        } else if (error.response.status === 403) {
                            this.errors.push({
                                message: 'Du har inte behörighet att utföra åtgärden.',
                            });
                        } else {
                            const defaultErrorMessage = 'Något gick fel när åtgärden skulle genomföras.';
                            const responseErrorMessage = error.response.data.message;

                            this.errors.push({
                                message: responseErrorMessage || defaultErrorMessage,
                            });
                        }

                        this.loading = false;
                    });
            },
        },
    };
</script>
